"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WSCategory = exports.LatestUpdateSource = exports.TransactionType = exports.PaymentChannel = exports.TransactionStatus = void 0;
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["Active"] = "Active";
    TransactionStatus["Inactive"] = "Inactive";
    TransactionStatus["Pending"] = "Pending";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
;
var PaymentChannel;
(function (PaymentChannel) {
    PaymentChannel["Online"] = "Online";
    PaymentChannel["InStore"] = "InStore";
    PaymentChannel["Other"] = "Other";
})(PaymentChannel = exports.PaymentChannel || (exports.PaymentChannel = {}));
;
var TransactionType;
(function (TransactionType) {
    TransactionType["Expense"] = "Expense";
    TransactionType["Income"] = "Income";
    TransactionType["Transfer"] = "Transfer";
    TransactionType["Fee"] = "Fee";
    TransactionType["ATMTransaction"] = "ATMTransaction";
    TransactionType["Reward"] = "Reward";
    TransactionType["Unknown"] = "Unknown";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
;
var LatestUpdateSource;
(function (LatestUpdateSource) {
    LatestUpdateSource["Plaid"] = "Plaid";
    LatestUpdateSource["System"] = "System";
    LatestUpdateSource["User"] = "User";
})(LatestUpdateSource = exports.LatestUpdateSource || (exports.LatestUpdateSource = {}));
;
var WSCategory;
(function (WSCategory) {
    WSCategory["AdvertisingMarketing"] = "Advertising & Marketing";
    WSCategory["ATMTransaction"] = "ATM Transaction";
    WSCategory["BankFee"] = "Bank Fee";
    WSCategory["BusinessInsurance"] = "Business Insurance";
    WSCategory["BusinessLicense"] = "Business License";
    WSCategory["CarExpenses"] = "Car Expense";
    WSCategory["Commission"] = "Commission";
    WSCategory["ContractorPayment"] = "Contractor Payment";
    WSCategory["Education"] = "Education";
    WSCategory["Entertainment"] = "Entertainment";
    WSCategory["Gift"] = "Gift";
    WSCategory["HomeExpenses"] = "Home Expense";
    WSCategory["Income"] = "Income";
    WSCategory["Interest"] = "Interest";
    WSCategory["LegalProfessionalService"] = "Legal & Professional Service";
    WSCategory["Meal"] = "Meal";
    WSCategory["OfficeRent"] = "Office Rent";
    WSCategory["Other"] = "Other Business Expense";
    WSCategory["OtherDeductions"] = "Other Deductions";
    WSCategory["Payroll"] = "Payroll";
    WSCategory["PhoneBill"] = "Phone Bill";
    WSCategory["Software"] = "Software";
    WSCategory["Supplies"] = "Supplies";
    WSCategory["Taxes"] = "Taxes";
    WSCategory["TollFee"] = "TollFee";
    WSCategory["Transfer"] = "Transfer";
    WSCategory["TravelTransport"] = "Travel & Transport";
    WSCategory["VehiclesMachineryEquipment"] = "Vehicles, Machinery & Equipment";
    WSCategory["VeterinaryServices"] = "Veterinary Services";
})(WSCategory = exports.WSCategory || (exports.WSCategory = {}));
;
;
;
;
;
;
;
//# sourceMappingURL=transaction.js.map